interface Props {
  [key: string]: any
}

export default function CreditCardIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 22 22" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M17.2857 5.5H4.71429C3.41247 5.5 2.35714 6.55533 2.35714 7.85714V14.1429C2.35714 15.4447 3.41247 16.5 4.71429 16.5H17.2857C18.5875 16.5 19.6429 15.4447 19.6429 14.1429V7.85714C19.6429 6.55533 18.5875 5.5 17.2857 5.5Z"
        stroke="none"
        strokeWidth="2.04286"
      />
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M2.35714 9.42857H19.6429"
        stroke="none"
        strokeWidth="2.04286"
      />
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M6.28571 14.1429H9.42857"
        stroke="none"
        strokeLinecap="round"
        strokeWidth="2.04286"
      />
    </svg>
  )
}
